import React from "react";
import { Paperclip, Loader2 } from "lucide-react";

/**
 * Small paperclip button that opens a file picker for images.
 * Accepts callback `onFiles(FileList)` to hand off files to the parent.
 */
export default function AttachButton({ onFiles, disabled, uploading, count = 0, max = 1, size = "sm" }) {
  const inputRef = React.useRef(null);
  const dim = size === "md" ? "w-11 h-11" : "w-9 h-9";
  const icon = size === "md" ? "w-5 h-5" : "w-4 h-4";
  const atLimit = count >= max;

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(e) => {
          if (e.target.files?.length) onFiles(e.target.files);
          e.target.value = "";
        }}
        data-testid="attach-file-input"
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={disabled || uploading || atLimit}
        aria-label={atLimit ? `Max ${max} image${max === 1 ? "" : "s"}` : "Attach an image"}
        title={atLimit ? `Max ${max} image${max === 1 ? "" : "s"}` : "Attach an image"}
        className={`${dim} rounded-full flex items-center justify-center transition-colors focus-ring flex-shrink-0 text-white/60 hover:text-white hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed`}
        data-testid="attach-btn"
      >
        {uploading ? <Loader2 className={`${icon} animate-spin`} /> : <Paperclip className={icon} />}
      </button>
    </>
  );
}
